import React from 'react';
import PropTypes from 'prop-types';
import './CursorLabel.css';

import Cursor from './svg/Cursor';

function CursorLabel({ id, label, color = `#00BFFF`, className, style }) {
  return (
    <div id={id} className={`cursor-label ${className}`}>
      <Cursor color={color} />
      <div className={`cursor-label-block`} style={{ backgroundColor: color }}>
        {label}
      </div>
    </div>
  )
}

CursorLabel.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default CursorLabel;
